/**
 * @generated SignedSource<<581ba9d87c9ce9c5943018a04589f86d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type testPageConnectModelMutation$variables = {
  id: string;
  target: ModelDuplicateTargetInput;
};
export type testPageConnectModelMutation$data = {
  readonly connectModel: string;
};
export type testPageConnectModelMutation = {
  response: testPageConnectModelMutation$data;
  variables: testPageConnectModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "target"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "target",
        "variableName": "target"
      }
    ],
    "kind": "ScalarField",
    "name": "connectModel",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageConnectModelMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "testPageConnectModelMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "0484e988112fc3432ba75fabec380733",
    "id": null,
    "metadata": {},
    "name": "testPageConnectModelMutation",
    "operationKind": "mutation",
    "text": "mutation testPageConnectModelMutation(\n  $id: ID!\n  $target: ModelDuplicateTargetInput!\n) {\n  connectModel(id: $id, target: $target)\n}\n"
  }
};
})();

(node as any).hash = "0273aa5e89db73bc4436a5c22eb44639";

export default node;
